<template>
  <div class="edit-sector-modal-component">
    <v-select
      class="sectors"
      width="auto"
      variant="outlined"
      :items="partnerSectors"
      :label="$t('sectorEditor.editSectorModalComponent.sectorPlaceholder')"
      v-model="selectedSector"
      item-title="name"
      item-value="id"
      :menu-props="{
        closeOnClick: true,
        closeOnContentClick: true,
      }"
      :disabled="isMultiple"
    >
      <template v-slot:item="item">
        <div class="select-item" @click="selectSector(item)">{{item.item.title}}</div>
      </template>
    </v-select>
    <v-btn class="save-button"
      color="primary"
      @click="handleSave"
      prepend-icon="mdi-content-save"
      :disabled="(!this.selectedSector && isMultiple) || isMultiple"
    >
      {{ $t('sectorEditor.editSectorModalComponent.saveButtonTitle') }}
    </v-btn>
    <v-btn
      class="remove-button"
      color="red"
      @click="handleRemove"
      prepend-icon="mdi-delete"
      variant="text"
    >
      {{ $t('sectorEditor.editSectorModalComponent.deleteButtonTitle') }}
    </v-btn>
    <v-btn
      class="edit-sector-button"
      color="primary"
      @click="handleEdit"
      prepend-icon="mdi-pencil"
      variant="text"
      :disabled="!this.selectedSector"
    > 
      {{ $t('sectorEditor.editSectorModalComponent.editButtonTitle') }}
      </v-btn>
  </div>
</template>

<script>
export default {
  name: 'EditSectorModalComponent',
  props: {
    item: {
      type: Object
    },
    partnerSectors: {
      tpye: Array,
      required: true,
    },
    isMultiple: {
      type: Boolean,
      required: true,
    }
  },
  data() {
    return {
      selectedSector: undefined,
    }
  },
  mounted() {
    this.setSelectedSector();
  },
  methods: {
    setSelectedSector() {
      if (this.item) {
        this.selectedSector = this.item.attrs.id;
      }
    },
    selectSector(item) {
      this.selectedSector = item.item.raw.id;
    },
    handleRemove() {
      this.$emit('removeCurrentShape');
    },
    handleSave() {
      this.$emit('saveCurrentShape', this.selectedSector);
    },
    handleEdit() {
      this.$emit('editSeat', this.selectedSector);
    },
  },
  watch: {
    item() {
      this.setSelectedSector();
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-sector-modal-component  {
  .sectors :deep(.v-select__selection-text) {
    max-width: 200px;
    padding-top: 4px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
  .save-button {
    width: 100%;
    margin-bottom: 20px;
  }
  .remove-button {
    width: 100%;
    margin-bottom: 40px;
  }
  .edit-sector-button {
    width: 100%;
    &:hover {
      ::v-deep(.v-btn__content) {
        text-decoration: none !important;
      }
    }
    ::v-deep(.v-btn__content) {
      text-decoration: underline !important;
    }
  }
}
.select-item {
  width: 240px;
  padding: 4px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  border-radius: 4px;
  &:hover {
    background: #123456;
    color: white;
    cursor: pointer;
  }
}
</style>